import _lodash, { set,get } from 'lodash'
import { message } from 'antd'
import { getCookie } from '@/public/utils'

// 下拉框
export const selectDataConversion = (data) => {
  if (!Array.isArray(data)) {
    return []
  }
  return data.map((item) => {
    const {id, name} = item
    return ({
      ...item,
      label: name,
      value: id
    })
  })
}

// 保存基本信息
export const basicInformationDataConversion = (basicInformationData) => {
  let _isRequired = true
  for (let item in basicInformationData) {
    if (basicInformationData[item] === '' || basicInformationData[item] === null || basicInformationData[item] === undefined || basicInformationData[item].length === 0) {
      if (item === 'name') {
        message.warning('请填写供应商', 2)
        return false
      }
      if (item === 'legal') {
        message.warning('请填写法人代表', 2)
        return false
      }
      if (item === 'money_type') {
        message.warning('请选择币种', 2)
        return false
      }
      if (item === 'registered_capital') {
        message.warning('请填写注册资本', 2)
        return false
      }
      if (item === 'address') {
        message.warning('请填写注册地址', 2)
        return false
      }
      if (item === 'pro_category') {
        message.warning('请勾选经营产品类型', 2)
        return false
      }
      if (item === 'operation_mode') {
        message.warning('请选择经营方式', 2)
        return false
      }
      if (item === 'taxpayer_category') {
        message.warning('请选择纳税人分类', 2)
        return false
      }
      if (item === 'tax_number') {
        message.warning('请填写税号', 2)
        return false
      }
      if (item === 'statement_mode') {
        message.warning('请选择账期', 2)
        return false
      }
      if (item === 'purchase_cycle') {
        message.warning('请填写生产周期', 2)
        return false
      }
      if (item === 'estimate_date') {
        message.warning('请填写发货天数', 2)
        return false
      }
      if (item === 'is_cross_border') {
        message.warning('请选择是否海淘供应商', 2)
        return false
      }
      if (item === 'is_supply_complaint') {
        message.warning('请选择是否支持无实物投诉', 2)
        return false
      }
      if (item === 'complaint_type'&&basicInformationData.is_supply_complaint) {
        message.warning('请填写投诉处理方式', 2)
        return false
      }
    }
  }

  // if (basicInformationData.statement_mode === '滚动账期') {
  //   if (!basicInformationData.account_period) {
  //     message.warning('请选择滚动账期天数', 2)
  //     return false
  //   }
  // }
  if (basicInformationData.statement_mode === '固定账期' || basicInformationData.statement_mode === '实销实结' || basicInformationData.statement_mode === '滚动账期') {
    if (basicInformationData.account_period === '' || basicInformationData.account_period === undefined ||basicInformationData.account_period === null) {
      message.warning('请选择账期天数', 2)
      return false
    }
  }

  if (basicInformationData.supplier_contact.length !== 0) {
    basicInformationData.supplier_contact.forEach((item) => {
      if (item.isRequired) {
        if (!item.contact_name || !item.phone || !item.identity_card || !item.email) {
          _isRequired = false
        }
      }
    })

    if (!_isRequired) {
      message.warning('请填写联系信息必填项', 2)
      return false
    }
  }

  for (let item in basicInformationData.supplier_logistic) {
    if (basicInformationData.supplier_logistic[item] === '' || basicInformationData.supplier_logistic[item] === null || basicInformationData.supplier_logistic[item] === undefined) {
      if (item === 'logistics_contactor') {
        message.warning('请填写收货人', 2)
        return false
      }

      if (item === 'logistics_tel'&&item === 'tel') {
        message.warning('请填写联系手机或固话', 2)
        return false
      }

      if (item === 'logistics_province') {
        message.warning('请选择售后地址省份', 2)
        return false
      }
      if (item === 'logistics_city') {
        message.warning('请选择售后地址市区', 2)
        return false
      }
      if (item === 'logistics_address') {
        message.warning('请选择售后地址详细地址', 2)
        return false
      }
    }
  }
}

export const brandInformationDataConversion = (paramData) => {
  let isRequre = true
  if (paramData.supplier_brand_bos.length !== 0) {
    paramData.supplier_brand_bos.forEach((item) => {
      if (item.brand_qualification_bos.length !== 0) {
        item.brand_qualification_bos.forEach((item2) => {
          if (item.brand_role === 1) {
            if (item2.sort === 1) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0 || !item2.qua_code || !item2.brand_type || !item2.brand_register) {
                isRequre = false
              }
            }

            if (item2.sort === 2) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }

            if (item2.sort === 4) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }
          } else {
            if (item2.sort === 1) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0 || !item2.qua_code || !item2.brand_type || !item2.brand_register) {
                isRequre = false
              }
            } else {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }
          }
        })
      }
      if (!isRequre) {
        item.FillIn = false
      } else {
        item.FillIn = true
      }
    })
  }

  return paramData
}

export const baseInfoSetNulByHide = (qualificationData) => {
  if (get(qualificationData,'length') !== 0) {
    qualificationData.forEach((item) => {
      if (item.qua_field_list.length !== 0) {
        item.qua_field_list.forEach((item2) => {
          if(!item.is_show){set(item2,'qua_field_value',null)}
        })
      }
    })
  }
  return qualificationData
}

export const brandInformationDataJudgment = (paramData) => {
  let isRequre = true
  let isRequires = true
  if (paramData.supplier_brand_bos.length !== 0) {
    paramData.supplier_brand_bos.forEach((item) => {
      if (item.brand_qualification_bos.length !== 0) {
        item.brand_qualification_bos.forEach((item2) => {
          if (item.brand_role === 1) {
            if (item2.sort === 1) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0 || !item2.qua_code || !item2.brand_type || !item2.brand_register) {
                isRequre = false
              }
            }

            if (item2.sort === 2) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }

            if (item2.sort === 4) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }
          } else {
            if (item2.sort === 1) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0 || !item2.qua_code || !item2.brand_type || !item2.brand_register) {
                isRequre = false
              }
            } else {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }
          }
        })
      }
      if (!isRequre) {
        message.error(item.brand_name + '必填项未填', 2)
        return false
      } else {
        return true
      }
    })
  }
  return isRequre
}

export const jumpUrl = (key, id, status) => {
  let url = ''
  if (status === '203') {
    if (key === 0) {
      url = window.location.origin + '/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection'
      window.open(url)
    }
  }

}

// 查询接口返回数据转换：新格式 -> 旧格式
export const transformQueryResponse = (data) => {
  const base = data.supplier_base || {}
  const contactList = data.supplier_contact_list || []
  const finance = data.supplier_finance || {}
  const bankList = data.supplier_finance_bank_list || []
  const other = data.supplier_other || {}

  // 提取 AfterSaleContact 作为售后信息
  const afterSaleContact = contactList.find(item => item.contact_type === 'AfterSaleContact') || {}
  const normalContacts = contactList.filter(item => item.contact_type !== 'AfterSaleContact')

  // 基础信息
  const baseInfo = {
    supplier_status:base.supplier_status,
    supplier_name: base.supplier_name,
    legal: base.legal_person,
    address: base.register_address,
    credit_code: base.license_number,
    manage_property_key: base.manage_property,
    is_cross_border: base.is_cross_border,
    pro_category_list_code: base.product_category ? base.product_category.split(',') : [],
    operation_mode_key: base.operation_mode,
    taxpayer_category_key: finance.taxpayer_category,
    money_type_key: base.money_type,
    registered_capital: base.register_capital,
    purchase_cycle: base.purchase_cycle,
    estimate_date: base.estimate_arrival_date,
    request_business_id: base.company_code,
    business_name: base.company_name,
    po_subject_code: base.po_subject_code,
    business_source_key: base.trade_type === 'CommonJKTrade' ? 'WithinChinaCompany' : 'OverseasCompanyContainsGAT',
    invoice_type_key: base.trade_type === 'CommonJKTrade' ? finance.invoice_type : 'FormInvoice',
    tax_rate: base.trade_type === 'CommonJKTrade' ? (finance.invoice_tax_rate != null ? String(finance.invoice_tax_rate) : null) : '0',
    statement_mode_key: finance.settlement_method,
    account_period: finance.payment_days,
    compute_standard: finance.payment_calibre,
    settlement_money_type_key: finance.settlement_currency,
    is_supply_complaint: other.complaint_form,
    claim_rule: other.complaint_claim_rule,
    claim_handling_method: other.complaint_claim_dispose_method,
    purchasing_manager_user_id: base.purchasing_manager_user_id || null,
  }

  // 联系人信息
  const contacts = normalContacts.map(item => ({
    id: item.id,
    category: item.contact_type,
    contact_name: item.contact_name,
    phone: item.phone_number,
    tel: item.tel,
    email: item.email,
  }))

  // 售后信息
  const supplierLogistics = {
    after_sale_contact_id: afterSaleContact.id,
    logistics_contactor: afterSaleContact.contact_name,
    logistics_tel: afterSaleContact.phone_number,
    logistics_province: afterSaleContact.province,
    logistics_city: afterSaleContact.city,
    logistics_district: afterSaleContact.area,
    logistics_address: afterSaleContact.address,
  }

  // 银行账户
  const openBankList = bankList.map(item => ({
    id: item.id,
    account_type: item.account_category === 'in_country' ? 0 : 1,
    bank_account: item.bank_account,
    account_name: item.account_name,
    bank_name: item.bank_name,
    bank_full_name: item.bank_full_name,
    province: item.province,
    city: item.city,
    united_bank_code: item.united_bank_code,
    currency: item.currency,
    bank_address: item.bank_address,
    company_address: item.company_address,
    swift_code: item.swift_code,
    ...item,
  }))

  return {
    ...baseInfo,
    supplier_contact_list: contacts,
    supplier_logistics: supplierLogistics,
    open_bank_list: openBankList,
  }
}

// 参数转换：旧格式 -> 新格式
export const transformSaveParams = (oldParams) => {
  const {
    supplier_contact_list = [],
    supplier_logistics = {},
    open_bank_list = [],
    operate_type,
    ...baseInfo
  } = oldParams

  // 转换 supplier_base
  const supplier_base = {
    supplier_code:getCookie("supplier_code")||"",
    supplier_name: baseInfo.supplier_name,
    legal_person: baseInfo.legal,
    register_address: baseInfo.address,
    license_number: baseInfo.credit_code,
    manage_property: baseInfo.manage_property_key,
    is_cross_border: baseInfo.is_cross_border === true,
    product_category: (baseInfo.pro_category_list_code || []).join(','),
    operation_mode: baseInfo.operation_mode_key,
    taxpayer_category: baseInfo.taxpayer_category_key,
    money_type: baseInfo.money_type_key,
    register_capital: baseInfo.registered_capital,
    purchase_cycle: baseInfo.purchase_cycle,
    estimate_arrival_date: baseInfo.estimate_date,
    company_code: getCookie("supplier_company_code")||"",
    company_name: getCookie("supplier_company_name")||"",
    po_subject_code: baseInfo.po_subject_code,
    generate_method: 'scs',
    scs_account_id: Number(getCookie('accountId')) || null,
    supplier_status: getCookie("supplier_code")?baseInfo.supplier_status:'ScsBaseWaitSubmit',
    is_enable: 'false',
    supplier_group:"outside",
    is_submit:operate_type == 'submit'?true:false,
    purchasing_manager_user_id: baseInfo.purchasing_manager_user_id || null,
    purchasing_manager_user_name: baseInfo.purchasing_manager_user_name || '',
  }

  // 转换 supplier_contact_list
  const contactList = supplier_contact_list.map(item => ({
    id: item.id,
    contact_type: item.category,
    contact_name: item.contact_name,
    phone_number: item.phone,
    tel: item.tel,
    email: item.email,
  }))

  // 将售后信息转换为 AfterSaleContact 类型的联系人
  if (supplier_logistics && supplier_logistics.logistics_contactor) {
    const afterSaleContact = {
      id: supplier_logistics.after_sale_contact_id,
      contact_type: 'AfterSaleContact',
      contact_name: supplier_logistics.logistics_contactor,
      phone_number: supplier_logistics.logistics_tel,
      province: supplier_logistics.logistics_province,
      city: supplier_logistics.logistics_city,
      area: supplier_logistics.logistics_district,
      address: supplier_logistics.logistics_address,
    }
    contactList.push(afterSaleContact)
  }

  // 转换 supplier_finance
  const supplier_finance = {
    taxpayer_category: baseInfo.taxpayer_category_key,
    invoice_type: baseInfo.invoice_type_key,
    invoice_tax_rate: baseInfo.tax_rate,
    settlement_currency: baseInfo.settlement_money_type_key,
    settlement_method: baseInfo.statement_mode_key,
    payment_days: baseInfo.account_period,
    payment_calibre: baseInfo.compute_standard,
  }

  // 转换 supplier_finance_bank_list
  const bankList = open_bank_list.map(item => ({
    id: item.id,
    account_category: item.account_type === 0 ? 'in_country' : 'foreign',
    bank_account: item.bank_account,
    account_name: item.account_name,
    bank_name: item.bank_name,
    bank_full_name: item.bank_full_name,
    province: item.province,
    city: item.city,
    united_bank_code: item.united_bank_code,
    currency: item.currency,
    bank_address: item.bank_address,
    company_address: item.company_address,
    swift_code: item.swift_code,
  }))

  // 转换 supplier_other
  const supplier_other = {
    complaint_form: baseInfo.is_supply_complaint,
    complaint_claim_rule: baseInfo.claim_rule,
    complaint_claim_dispose_method: baseInfo.claim_handling_method,
  }

  return {
    supplier_base,
    supplier_contact_list: contactList,
    supplier_finance,
    supplier_finance_bank_list: bankList,
    supplier_other,
    operator_system: 'scs',
  }
}



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/utils.js